// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid-staff-info[data-v-6ce1f057]{display:grid;grid-template:auto 1fr/auto 1fr}@media (min-width: 768px){.transform-staff-header[data-v-6ce1f057]{width:6rem;margin:0 0 0 auto;padding:0;position:relative;z-index:10;transform:translateY(-2.15rem)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
